/**
 * 请求错误码对应的中英文本
 */
export default {
  dbl_error_1: 'Loading failed', // 兜底文本
  dbl_error_10013: '{name} error: invalid reference field, Error 400：{msg}',
  dbl_error_53005: 'The dataset lacks user attributes and does not support user filtering.',
};